export const ROUTE_PATH = '/executive-reports';

export const FEATURE_NAME = 'executiveReportsPage';
